interface ControlData {
  sensitivity?: number;
  specificity?: number;
  pretest?: number;
  [key: string]: any;
}

interface PlotPoint {
  x: number;
  y: number;
  c: string;
}

const updateFunc = (controlData: ControlData): PlotPoint[] => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;
  const pretest =
    controlData["pretest"] !== undefined ? controlData["pretest"] : 50;
  const pretest1 = pretest;
  let sensitivity1 = sensitivity / 100;
  let specificity1 = specificity / 100;
  let lr_pos1 = sensitivity1 / (1 - specificity1);
  let lr_neg1 = (1 - sensitivity1) / specificity1;
  const start = 0;
  const end = 1;
  const increment = 0.001;
  const pretestrange1 = Array.from(
    { length: Math.ceil((end - start) / increment) + 1 },
    (_, index) => start + index * increment
  );
  let pretest_odds1 = pretestrange1.map((element) => element / (1 - element));
  pretest_odds1[pretestrange1.length - 1] = 100;
  let posttest_odds_pos1 = pretest_odds1.map((element) => element * lr_pos1);
  let posttest_odds_neg1 = pretest_odds1.map((element) => element * lr_neg1);
  let posttest_pos1 = posttest_odds_pos1.map(
    (element) => element / (1 + element)
  );
  let posttest_neg1 = posttest_odds_neg1.map(
    (element) => element / (1 + element)
  );
  posttest_neg1[pretestrange1.length - 1] = 1;
  let notest1: number[] = [];
  notest1 = Array.from(
    { length: (end - start) / increment + 1 },
    (_, i) => start + i * increment
  );
  let posttest1 = 1;
  let posttest1pos = 1;
  let posttest1neg = 1;
  let calculatedDataNomogramPlotNotest: PlotPoint[] = [];
  calculatedDataNomogramPlotNotest = notest1.map((_, i) => ({
    x: pretestrange1[i] * 100,
    y: notest1[i] * 100,
    c: "Without test",
  }));
  let calculatedDataNomogramPlotPostest: PlotPoint[] = [];
  calculatedDataNomogramPlotPostest = notest1.map((_, i) => ({
    x: pretestrange1[i] * 100,
    y: posttest_pos1[i] * 100,
    c: "Positive test",
  }));
  let calculatedDataNomogramPlotNegtest: PlotPoint[] = [];
  calculatedDataNomogramPlotNegtest = notest1.map((_, i) => ({
    x: pretestrange1[i] * 100,
    y: posttest_neg1[i] * 100,
    c: "Negative test",
  }));
  sensitivity1 = sensitivity / 100;
  specificity1 = specificity / 100;
  lr_pos1 = sensitivity1 / (1 - specificity1);
  lr_neg1 = (1 - sensitivity1) / specificity1;
  pretest_odds1 = pretestrange1.map((element) => element / (1 - element));
  pretest_odds1[pretestrange1.length - 1] = 100;
  posttest_odds_pos1 = pretest_odds1.map((element) => element * lr_pos1);
  posttest_odds_neg1 = pretest_odds1.map((element) => element * lr_neg1);
  posttest_pos1 = posttest_odds_pos1.map((element) => element / (1 + element));
  posttest_neg1 = posttest_odds_neg1.map((element) => element / (1 + element));
  posttest_neg1[pretestrange1.length - 1] = 1;
  posttest1pos = posttest_pos1[pretest1 * 10 + 1] * 100;
  posttest1neg = posttest_neg1[pretest1 * 10 + 1] * 100;
  if (isNaN(posttest1pos)) {
    posttest1pos = 100;
  }
  if (isNaN(posttest1neg)) {
    posttest1neg = 100;
  }
  if (posttest1pos < 3) {
    posttest1pos = 0;
  }
  posttest1 = posttest_pos1[pretest1 * 10 + 1] * 100;
  const posttest1round = Math.round(posttest1);
  const pointData: PlotPoint = { x: 5, y: posttest1round, c: "Posterior" };
  posttest_neg1 = posttest_neg1.map((element) => element * 100);
  posttest_pos1 = posttest_pos1.map((element) => element * 100);
  sensitivity1 = sensitivity1 * 100;
  specificity1 = specificity1 * 100;
  lr_pos1 = sensitivity1 / 100 / (1 - specificity1 / 100);
  lr_neg1 = (1 - sensitivity1 / 100) / (specificity1 / 100);
  const calculatedDataNomogramPlotPosterior1: PlotPoint[] = [
    { x: pretest1, y: 0, c: "Posterior1" },
    { x: pretest1, y: posttest1pos, c: "Posterior1" },
    { x: 0, y: posttest1pos, c: "Posterior1" },
  ];
  const calculatedDataNomogramPlotPosterior2: PlotPoint[] = [
    { x: pretest1, y: 0, c: "Posterior2" },
    { x: pretest1, y: pretest1, c: "Posterior2" },
    { x: 0, y: pretest1, c: "Posterior2" },
  ];
  const calculatedDataNomogramPlotPosterior3: PlotPoint[] = [
    { x: pretest1, y: 0, c: "Posterior3" },
    { x: pretest1, y: posttest1neg, c: "Posterior3" },
    { x: 0, y: posttest1neg, c: "Posterior3" },
  ];
  const calculatedDataNomogramPlot = calculatedDataNomogramPlotNotest.concat(
    calculatedDataNomogramPlotPostest,
    calculatedDataNomogramPlotNegtest,
    calculatedDataNomogramPlotPosterior1,
    calculatedDataNomogramPlotPosterior2,
    calculatedDataNomogramPlotPosterior3
  );
  calculatedDataNomogramPlot.push(pointData);
  return calculatedDataNomogramPlot;
};
export default updateFunc;
